export default function(sum) {
    // return sum.toLocaleString()
    if(sum > 1000) {
        return Math.round(sum).toLocaleString();
    }
    return sum
}